import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=51905250&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/style.css?vue&type=style&index=0&id=51905250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51905250",
  null
  
)

export default component.exports